<template>
  <div>
    <h4>{{ $t('creator.similarProposals') }}</h4>

    <component :is="vue_horizontal" responsive class="horizontal my-2" :displacement="0.3" snap="center" v-if="loader">
      <card-category 
        :redirect="true"
        v-for="(item, index) in results" :key="index"
        :proposal="item"
        :width="'300px'"
        :countries="countries"
        class="mr-1"
      />
    </component>
  </div>
</template>

<script>
import cardCategory from "@/views/pages/proposals/cardCategory.vue";
import { getCountries } from '@/libs/utils/others';
import { makeSearchProposalsUseCase } from "@/application/proposals/SearchProposals.usecase";

export default {
  name: 'SimilarProposals',
  components: {
    cardCategory,
  },
  props: {
    networks: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    countries() {
      return getCountries();
    }
  },
  data() {
    return {
      results: [],
      vue_horizontal: null,
      loader: false
    }
  },
  async mounted() {
    this.vue_horizontal = (await import('vue-horizontal')).default;
  },
  async created() {
    try {
      const execute = makeSearchProposalsUseCase(null, {}, this.networks, 10, 1, this.$route.params.vanity_name);
      const { results } = await execute();
      this.results = results;
    } catch (error) {
      this.results = [];
    } finally {
      this.loader = true;
    }
  }
}
</script>